import * as React from 'react';
import { Page, Label, HTML } from 'src/components/Layout';
import Helptext from 'src/components/Helptext';
import { initiateBrandingClothesRedirect } from 'src/utils/brandingclothes.utils';
import { useToast } from 'src/components/Toast';
import { useDispatch, useSelector } from 'react-redux';
import LoadingIndicator from 'src/components/LoadingIndicator';
import { useHistory } from 'react-router-dom';
import { getIsSuperuser } from 'src/store/profile/profile.selectors';

export const BrandingClothes = () => {
  const [isLoading, setIsLoading] = React.useState(false);

  const dispatch = useDispatch();
  const toast = useToast();
  const history = useHistory();

  const enableWorkwearPunchout = useSelector(getIsSuperuser);

  React.useEffect(() => {
  
    if (!enableWorkwearPunchout || isLoading) return;
    setIsLoading(true);
  
    initiateBrandingClothesRedirect(
      null, 
      dispatch, 
      toast, 
      // Error callback - navigate to home
      () => {
        history.push('/');
      },
      // Success callback - go back to previous page
      () => {
        // Navigate back to the previous page
        if (history.length > 1) {
          history.goBack();
        } else {
          history.push('/');
        }
  
        toast.addSuccess('Profileringstøy-siden er åpnet i en ny fane');
      },
      // Pass the loading state setter
      setIsLoading
    );
  }, [isLoading, dispatch, toast, history]);

  if (enableWorkwearPunchout) {
    return <LoadingIndicator withText customTxt="Omdirigerer ..." />;
  }

  return (
    <Page title="Profileringsklær" style={{ alignItems: 'center' }}>
      <Label as="h1" marginTop="0.5em" marginBottom="0.5em">
        Profileringsklær
      </Label>

      <Helptext
        name="profiling-clothes"
        render={(html) => html && <HTML style={{ width: '80%', maxWidth: '850px' }}>{html}</HTML>}
      />
    </Page>
  );
};
